document.addEventListener("DOMContentLoaded", function () {
  function initActiveStates() {
    document.querySelectorAll(".variant-images-wrapper").forEach(function (group) {
      const items = group.querySelectorAll(".variant-image-item");
      if (items.length > 0 && !group.dataset.initialized) {
        items.forEach(function (sibling) {
          sibling.classList.remove("active");
        });
        items[0].classList.add("active");
        group.dataset.initialized = "true";
      }
    });
  }

  function updateMainProductImage(variantImageItem) {
    const productCard = variantImageItem.closest('.product-card-wrapper');
    if (!productCard) return;

    const variantId = variantImageItem.dataset.variantId;
    const variantTitle = variantImageItem.dataset.variantTitle;

    // Update the hidden variant input for Add to Cart
    const variantInput = productCard.querySelector('[data-variant-input]');
    if (variantInput && variantId) {
      variantInput.value = variantId;
    }
    
    const mainImageContainer = productCard.querySelector('.product-card__image');
    if (!mainImageContainer) return;

    const allVariantContainers = mainImageContainer.querySelectorAll('[data-variant-title]');
    let variantImageContainer = null;
    
    for (const container of allVariantContainers) {
      if (container.dataset.variantTitle === variantTitle) {
        variantImageContainer = container;
        break;
      }
    }
    
    if (!variantImageContainer) {
      const productJsonScript = productCard.querySelector('script[type="application/json"]');
      if (productJsonScript) {
        try {
          const productData = JSON.parse(productJsonScript.textContent);
          const variant = productData.variants.find(v => v.id.toString() === variantId);
          
          if (variant && variant.featured_image && variant.featured_image.src) {
            const mainImg = mainImageContainer.querySelector('.media img');
            if (mainImg) {
              const baseUrl = variant.featured_image.src;
              const newSrc = baseUrl.replace(/(\.[^.]+)$/, '_533x$1');
              
              mainImg.src = newSrc;
              mainImg.alt = variant.featured_image.alt || variantTitle;
              
              const widths = [165, 360, 533, 720, 940, 1066];
              const srcset = widths.map(width => {
                const sizedUrl = baseUrl.replace(/(\.[^.]+)$/, `_${width}x$1`);
                return `${sizedUrl} ${width}w`;
              }).join(', ');
              
              mainImg.srcset = srcset;
            }
          }
        } catch (e) {
          console.error('Error parsing product JSON:', e);
        }
      }
    } else {
      const allVariantImages = mainImageContainer.querySelectorAll('.product-card__image__variant');
      allVariantImages.forEach(img => {
        img.style.display = 'none';
        img.style.opacity = '0';
      });
      variantImageContainer.style.display = 'block';
      variantImageContainer.style.opacity = '1';
      variantImageContainer.style.position = 'absolute';
      variantImageContainer.style.top = '0';
      variantImageContainer.style.left = '0';
      variantImageContainer.style.width = '100%';
      variantImageContainer.style.height = '100%';
      variantImageContainer.style.zIndex = '2';
    }
    const productLink = productCard.querySelector('.product-card__image-wrapper');
    if (productLink && variantId) {
      const currentHref = productLink.href;
      const url = new URL(currentHref);
      url.searchParams.set('variant', variantId);
      productLink.href = url.toString();
    }
  }

  initActiveStates();
  document.addEventListener("click", function (e) {
    const item = e.target.closest(".variant-image-item");
    if (item) {
      const group = item.closest(".variant-images-wrapper");
      if (group) {
        const items = group.querySelectorAll(".variant-image-item");
        items.forEach(function (sibling) {
          sibling.classList.remove("active");
        });
        item.classList.add("active");
        updateMainProductImage(item);
      }
    }
  });
  document.addEventListener("mouseover", function (e) {
    const item = e.target.closest(".variant-image-item");
    if (item) {
      const tooltip = item.querySelector(".variant-tooltip");
      if (tooltip) tooltip.style.opacity = "1";
    }
  });

  document.addEventListener("mouseout", function (e) {
    const item = e.target.closest(".variant-image-item");
    if (item) {
      const tooltip = item.querySelector(".variant-tooltip");
      if (tooltip) tooltip.style.opacity = "0";
    }
  });

  const observer = new MutationObserver(function () {
    initActiveStates();
  });

  observer.observe(document.body, { childList: true, subtree: true });
});

